@for (c of [current()]; track c) {
<fa-icon [icon]="c.icon" class="[grid-area:1/1]"
         animate.enter="icon-enter" animate.leave="icon-leave"></fa-icon>
}